import { FormFieldProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: FormFieldProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as FormFieldProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: <div />,
    } as FormFieldProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
